import { TViewCommonOption } from '@libs/types';
import clsx from 'clsx';
import React from 'react';
import { TVisualOption } from '../../../types/options';
import { FlagIcon } from '../FlagIcon/FlagIcon';
import styles from './badge.module.css';

type TBadgeProps = {
    flagIcon?: string;
    size?: TVisualOption['size'];
} & Pick<TViewCommonOption, 'isDisabled' | 'styleName' | 'parentStyleNames'>;

export const Badge = (props: TBadgeProps) => {
    return (
        <span className={clsx(styles.badgeContainer, styles[`${props.size}`])}>
            <FlagIcon
                name={props.flagIcon}
                size={props.size === 'medium' ? '20px' : '16px'}
                parentStyleNames={props.parentStyleNames}
                styleName={props.styleName}
                isDisabled={props.isDisabled}
            />
        </span>
    );
};
